import React from 'react';
import { connect } from 'react-redux';

import * as notificationActions from '@/shared/modules/notification/actions';

import NotificationMessage from './NotificationMessage';

import type { NotificationState } from '@/shared/modules/notification/types';

interface NotificationProps {
	notifications: NotificationState['notifications'];
	closeNotification: typeof notificationActions.closeNotification;
}

const Notification = ({ notifications, closeNotification }: NotificationProps) => {
	if (!notifications.length) {
		return null;
	}

	return (
		<div className="notification-wrapper">
			{notifications.map((item) => (
				<NotificationMessage
					key={item.id}
					id={item.id}
					title={item.title}
					subtitle={item.subtitle}
					timeout={item.timeout}
					error={item.error}
					closeNotification={(id) => closeNotification(id)}
				/>
			))}
		</div>
	);
};

function mapStateToProps({ notificationReducer }: any) {
	return {
		notifications: notificationReducer.notifications,
	};
}

const mapDispatchToProps = {
	closeNotification: notificationActions.closeNotification,
};

export default connect(mapStateToProps, mapDispatchToProps)(Notification);
